/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from '@/shared/api/axios-client'
import type { GetStatsByDriversQueryResponse, GetStatsByDriversQueryParams, GetStatsByDrivers400 } from '../entities/GetStatsByDrivers'
import type { RequestConfig, ResponseErrorConfig } from '@/shared/api/axios-client'
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query'
import { getStatsByDrivers } from '../api/getStatsByDrivers'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getStatsByDriversQueryKey = (params: GetStatsByDriversQueryParams) => [{ url: '/stats/by-drivers' }, ...(params ? [params] : [])] as const

export type GetStatsByDriversQueryKey = ReturnType<typeof getStatsByDriversQueryKey>

export function getStatsByDriversQueryOptions(params: GetStatsByDriversQueryParams, config: Partial<RequestConfig> & { client?: typeof client } = {}) {
  const queryKey = getStatsByDriversQueryKey(params)
  return queryOptions<GetStatsByDriversQueryResponse, ResponseErrorConfig<GetStatsByDrivers400>, GetStatsByDriversQueryResponse, typeof queryKey>({
    enabled: !!params,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal
      return getStatsByDrivers(params, config)
    },
  })
}

/**
 * @description Get stats by drivers
 * @summary Get stats by drivers
 * {@link /stats/by-drivers}
 */
export function useGetStatsByDrivers<
  TData = GetStatsByDriversQueryResponse,
  TQueryData = GetStatsByDriversQueryResponse,
  TQueryKey extends QueryKey = GetStatsByDriversQueryKey,
>(
  params: GetStatsByDriversQueryParams,
  options: {
    query?: Partial<QueryObserverOptions<GetStatsByDriversQueryResponse, ResponseErrorConfig<GetStatsByDrivers400>, TData, TQueryData, TQueryKey>> & {
      client?: QueryClient
    }
    client?: Partial<RequestConfig> & { client?: typeof client }
  } = {},
) {
  const { query: { client: queryClient, ...queryOptions } = {}, client: config = {} } = options ?? {}
  const queryKey = queryOptions?.queryKey ?? getStatsByDriversQueryKey(params)

  const query = useQuery(
    {
      ...(getStatsByDriversQueryOptions(params, config) as unknown as QueryObserverOptions),
      queryKey,
      ...(queryOptions as unknown as Omit<QueryObserverOptions, 'queryKey'>),
    },
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<GetStatsByDrivers400>> & { queryKey: TQueryKey }

  query.queryKey = queryKey as TQueryKey

  return query
}